import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { DateBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeCashFlowExpenseSubReportDetailMutation,
  useCreateCashFlowExpenseSubReportDetailMutation,
  useLazyGetCashFlowExpenseSubReportDetailQuery,
} from 'bus/cash';
import { CashFlowExpenseSubReportDetailItem } from 'bus/cash/types/cashFlowExpenseSubReport';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  cashFlowId: number;
};

const initialForm: CashFlowExpenseSubReportDetailItem = {
  cashFlowItemId: null,
  comment: '',
  confirmedSum: 0,
  date: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, cashFlowId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<CashFlowExpenseSubReportDetailItem>(initialForm);

  const [loadCashFlowExpenseSubReport] = useLazyGetCashFlowExpenseSubReportDetailQuery();
  const [createCashFlowExpenseSubReport, { isLoading: isLoadingCreate }] =
    useCreateCashFlowExpenseSubReportDetailMutation();
  const [changeCashFlowExpenseSubReport, { isLoading: isLoadingChange }] =
    useChangeCashFlowExpenseSubReportDetailMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    if (id) {
      const result = await loadCashFlowExpenseSubReport({ cashFlowId, detailId: id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const requestDateSource = useMemo(() => {
    const defaultFilter = ['cashFlowType', '=', '1'];
    return $createDataSource('/v1/CashFlowItem', 'id', { defaultFilter });
  }, []);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeCashFlowExpenseSubReport({ ...form, cashFlowId, detailId: id });
      } else {
        await createCashFlowExpenseSubReport({ ...form, cashFlowId, detailId: id });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Расходы в подотчет"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, date: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Статья движения ДС" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={requestDateSource}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.cashFlowItemId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, cashFlowItemId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions
                              title="Выберите Статья движения ДС"
                              closeOnOutsideClick={true}
                              showTitle={false}
                            />
                            <Validator>
                              <RequiredRule message="Выберите Статья движения ДС" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Сумма, руб." labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.confirmedSum}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, confirmedSum: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма, руб." />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
